import { Building2 } from 'lucide-react'

export function AppuntamentoChip({ wo }: { wo: any }) {
  if (!wo.ora_apertura && !wo.ora_chiusura) return <span style={{ color: 'var(--text-600)' }}>—</span>

  const isLong   = wo.ora_chiusura != null && wo.ora_chiusura > '14:00'
  const isShort  = wo.ora_chiusura?.startsWith('13:')
  const style = isLong
    ? { background: '#f0fdf4', color: '#15803d', border: '1px solid #bbf7d0' }
    : isShort
      ? { background: '#fefce8', color: '#92400e', border: '1px solid #fde68a' }
      : { background: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1' }

  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      padding: '1px 8px', borderRadius: 99, fontSize: 10, fontWeight: 600,
      whiteSpace: 'nowrap', width: 'fit-content', ...style,
    }}>
      <Building2 size={9} />
      {wo.ora_apertura ?? '?'}–{wo.ora_chiusura ?? '?'}
    </div>
  )
}
